export default function ProductCard({ product, onOpen }) {
  return (
    <article
      className="productCard"
      onClick={() => onOpen(product)}
    >
      <div className="imageWrap">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} />
        ) : (
          <span className="emoji">🎨</span>
        )}

        {product.badge && (
          <span className="badge">
            {product.badge}
          </span>
        )}
      </div>

      <div className="cardBody">
        <span className="category">
          {product.category}
        </span>

        <h3>{product.name}</h3>

        <strong className="price">
          {product.price ? `${product.price} €` : ''}
        </strong>
      </div>
    </article>
  );
}